import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import colors from "../../utils/colors";

const SIZE_PRESETS = {
  default: { button: 42, radius: "10px", icon: 22 },
  compact: { button: 36, radius: "8px", icon: 16 },
};

const RefreshIconButton = ({
  onClick,
  disabled = false,
  loading = false,
  size = "default",
}) => {
  const preset = SIZE_PRESETS[size] || SIZE_PRESETS.default;

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: preset.button,
        height: preset.button,
        minWidth: preset.button,
        minHeight: preset.button,
        borderRadius: preset.radius,
        border: `1px solid ${colors.neutral[200]}`,
        backgroundColor: "#fff",
        flexShrink: 0,
        p: 0,
        "&:hover": { backgroundColor: colors.neutral[50] },
        "&:disabled": { opacity: 0.5 },
      }}
    >
      <RefreshIcon
        sx={{
          fontSize: preset.icon,
          color: colors.primary[300],
          "@keyframes refreshSpin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
          animation: loading ? "refreshSpin 1s linear infinite" : "none",
        }}
      />
    </IconButton>
  );
};

RefreshIconButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(["default", "compact"]),
};

export default RefreshIconButton;
